import React from 'react';
import './App.css';
import CoinInfo from './components/CoinInfo'
function App() {
  return (
    <div className="App">
      <CoinInfo />
    </div>
  );
}

export default App;
